import {logger} from './logger'

export default [
	logger
];


// WEBPACK FOOTER //
// ./src/middlewares/index.js